/**
 * Created by evgenijsenkevic on 20.09.2024
 */

const RegionControl = function (unit, options, data) {
    UnitComponent.call(this, unit);
    
    this.region = data.region;
    this.decoratorCode = data.decoratorCode;

    if (data.region.includes("fence_")) {
        this.decoratorCode = Map2dFences.getDecoratorCode(data.decoratorCode, data.region);
    }

    this.skin = data.skin;
    this.brokenSkin = data.brokenSkin;

    this.iterateDecorators((decorator) => {
        decorator.setSkin(this.skin, true);
    });
};

RegionControl.prototype = Object.create(UnitComponent.prototype);
RegionControl.prototype.constructor = RegionControl;

RegionControl.prototype.iterateDecorators = function (iterator) {
    Map2d.currentMap.regions[this.region].positions.forEach((position) => {
        const decorators = Map2d.currentMap.decorators.getDecorators(position.x, position.y);

        const decorator = decorators && decorators.find((decorator) => decorator.code === this.decoratorCode);

        if (decorator) {
            iterator(decorator);
        }
    });
};

RegionControl.prototype.afterUpgradeStage = function (f) {
    f = f || function () {};
    let minX = Number.MAX_VALUE;
    let minY = Number.MAX_VALUE;

    let maxX = Number.MIN_VALUE;
    let maxY = Number.MIN_VALUE;

    this.iterateDecorators((decorator) => {
        minX = Math.min(decorator.x, minX);
        minY = Math.min(decorator.y, minY);

        maxX = Math.max(decorator.x, maxX);
        maxY = Math.max(decorator.y, maxY);
    });
    
    this.iterateDecorators((decorator) => {
        decorator.setSkin(this.brokenSkin, true);

        const animationDelay = RegionControl.ITERATE_DELAY * (decorator.x - minX + (decorator.y - minY) / 2);
        Map2d.currentMap.counter.setTimeout(() => {
            decorator.setSkin(this.skin);
        }, animationDelay);
    });

    Map2d.currentMap.counter.setTimeout(f, RegionControl.ITERATE_DELAY * (maxX - minX + (maxY - minY) / 2));
};

RegionControl.prototype.animateHover = function () {
    this.iterateDecorators((decorator) => {
        decorator.animateHover();
    });
};

RegionControl.prototype.stopAnimateHover = function () {
    this.iterateDecorators((decorator) => {
        decorator.stopAnimateHover();
    });
};

RegionControl.ITERATE_DELAY = 130;